export const getNextPaginationToken = (paginationToken: string): string | null =>
  paginationToken === '' || paginationToken === null ? null : paginationToken;
